module.exports = __webpack_public_path__ + "img/863-b49ba3.png";